import { ExtendedLocationDto } from "../api/aggregation-client/service";

export type LngLatTuple = [number, number];

const azeBounds = {
  minLng: 44.7,
  maxLng: 50.6,
  minLat: 38.3,
  maxLat: 41.9,
};

const isLngLatTuple = (coords: [number, number]): boolean => {
  return (
    coords[0] >= azeBounds.minLng &&
    coords[0] <= azeBounds.maxLng &&
    coords[1] >= azeBounds.minLat &&
    coords[1] <= azeBounds.maxLat
  );
};

const isLatLngTuple = (coords: [number, number]): boolean => {
  return (
    coords[0] >= azeBounds.minLat &&
    coords[0] <= azeBounds.maxLat &&
    coords[1] >= azeBounds.minLng &&
    coords[1] <= azeBounds.maxLng
  );
};

export const validateCoords = (location: ExtendedLocationDto | undefined): [number, number] | undefined => {
  if (!location?.coordinates || !("coordinates" in location.coordinates)) {
    return undefined;
  }

  const coords = location.coordinates.coordinates;

  if (!coords || !Array.isArray(coords) || coords.length !== 2 || !coords.every((param) => typeof param === "number")) {
    return undefined;
  }

  if (!(isLngLatTuple(coords as [number, number]) || isLatLngTuple(coords as [number, number]))) {
    return undefined;
  }

  return coords as [number, number];
};

export const normalizeCoords = (coords: [number, number]): LngLatTuple => {
  if (isLatLngTuple(coords as [number, number])) {
    return [coords[1], coords[0]];
  }

  return coords;
};
